import { FormControl, FormControlLabel, Radio } from '@mui/material'
import { capitalizeFirstChart } from '../../utils/helpers'

const OfoqRadioBtn = ({
  name, customPlaceHolder, defaultOption, refState, customStyle, transparentStyle,
}) => {
  const placeHolder = customPlaceHolder || name?.split('_')?.join(' ')

  const handleChangeHandler = (event) => {
    refState(event.target.value)
  }

  return (
    <FormControl fullWidth component="fieldset" sx={[customStyle && customStyle]}>
      <FormControlLabel
        required
        fullWidth
        control={<Radio style={styles.radioIcon} value={name} checked={defaultOption} />}
        value={name}
        name={capitalizeFirstChart(placeHolder)}
        id={`${name}-radioBtn`}
        label={capitalizeFirstChart(placeHolder)}
        variant="outlined"
        onChange={handleChangeHandler}
        sx={[styles.radioContainer,

          defaultOption && styles.activeRadioContainer,
          transparentStyle && styles.transparentStyle,
        ]}
        InputProps={{
          autoComplete: 'new-name',
          form: {
            autoComplete: 'off',
          },
        }}
      />
    </FormControl>
  )
}

const styles = {
  radioContainer: {
    width: '85%',
    height: '20px',
    margin: '4px 14px 16px 8px',
    padding: '16px',
    borderRadius: '8px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'grey.200',
    backgroundColor: 'background.default',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& .MuiTypography-root': {
      textTransform: 'capitalize',
      fontSize: '14px',
    },

    '& .MuiFormControlLabel-asterisk': {
      display: 'none',
    },
  },
  transparentStyle: {
    border: 'none',
    backgroundColor: 'transparent',
    margin: '0px',
    p: 0,
  },
  activeRadioContainer: {
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'grey.200',
    backgroundColor: 'primary.main',
    color: 'background.paper',

    '& .MuiIconButton-label': {
      color: 'background.paper !important',
    },
    '& .MuiSvgIcon-fontSizeMedium': {
      color: '#ffffff !important',
      fill: '#FFF',
    },
  },
}

export default OfoqRadioBtn
